import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';
import mergeClassNames from 'merge-class-names';
import Days from './MonthView/Days.js';
import Weekdays from './MonthView/Weekdays.js';
import WeekNumbers from './MonthView/WeekNumbers.js';
import { CALENDAR_TYPE_LOCALES, CALENDAR_TYPES } from './shared/const.js';
import { isCalendarType } from './shared/propTypes.js';
import { LegendContainer, LegendWrapper, Legend } from '../Indicators.js';

function getCalendarTypeFromLocale(locale) {
  return Object.keys(CALENDAR_TYPE_LOCALES).find(calendarType => CALENDAR_TYPE_LOCALES[calendarType].includes(locale)) || CALENDAR_TYPES.ISO_8601;
}
function MonthView(props) {
  const {
    activeStartDate,
    locale,
    onMouseLeave,
    showFixedNumberOfWeeks,
    surface
  } = props;
  const {
      calendarType = getCalendarTypeFromLocale(locale),
      formatShortWeekday,
      onClickWeekNumber,
      showWeekNumbers,
      indicators
    } = props,
    childProps = __rest(props, ["calendarType", "formatShortWeekday", "onClickWeekNumber", "showWeekNumbers", "indicators"]);
  function renderWeekdays() {
    return React.createElement(Weekdays, {
      calendarType: calendarType,
      formatShortWeekday: formatShortWeekday,
      locale: locale,
      onMouseLeave: onMouseLeave
    });
  }
  function renderWeekNumbers() {
    if (!showWeekNumbers) {
      return null;
    }
    return React.createElement(WeekNumbers, {
      activeStartDate: activeStartDate,
      calendarType: calendarType,
      onClickWeekNumber: onClickWeekNumber,
      onMouseLeave: onMouseLeave,
      showFixedNumberOfWeeks: showFixedNumberOfWeeks
    });
  }
  function renderDays() {
    return React.createElement(Days, Object.assign({
      indicators: indicators,
      surface: surface,
      calendarType: calendarType
    }, childProps));
  }
  const className = 'react-calendar__month-view';
  return React.createElement("div", {
    className: mergeClassNames(className, showWeekNumbers ? `${className}--weekNumbers` : '')
  }, React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'flex-end'
    }
  }, renderWeekNumbers(), React.createElement("div", {
    style: {
      flexGrow: 1,
      width: '100%'
    }
  }, renderWeekdays(), renderDays())), indicators && React.createElement(LegendContainer, {
    "aria-hidden": true
  }, React.createElement(LegendWrapper, null, indicators.map((data, index) => {
    return React.createElement(Legend, {
      key: index,
      type: index + 1,
      surface: surface
    }, React.createElement("span", null, data.label));
  }))));
}
MonthView.propTypes = {
  activeStartDate: PropTypes.instanceOf(Date).isRequired,
  calendarType: isCalendarType,
  formatShortWeekday: PropTypes.func,
  locale: PropTypes.string,
  onClickWeekNumber: PropTypes.func,
  onMouseLeave: PropTypes.func,
  showFixedNumberOfWeeks: PropTypes.bool,
  showWeekNumbers: PropTypes.bool
};

export { MonthView as default };
